import request  from '@/utils/request'
import qs from 'qs'


//  报告管理列表

export const getReprotList = params => {
  return request({
    url: '/api/report',
    method: 'GET',
    params:params,
    paramsSerializer: params => {
      return qs.stringify(params, {indices: false})  //处理数组
    }
  })
}

// 报告管理详情

export const getReprotListDetail = id => {
  return request({
    url: '/api/report/'+id,
    method: 'GET'
  })
}

// 删除管理报告
export const deteleReprotList = id => {
  return request({
    url: '/api/report/'+id,
    method: 'delete'
  })
}

// 添加报告

export const postReprotList = params => {
  return request({
    url: '/api/report',
    method: 'POST',
    data:params
  })
}


//修改报告

export const putReprotList = params => {
  return request({
    url: '/api/report',
    method: 'PUT',
    data:params
  })
}



// 增加报告附件
export const addPresentationFile = params => {
  return request({
    url: '/api/presentationFile',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 删除报告附件
export const deletePresentationFile = params => {
  return request({
    url: `/api/delPresentationFile`,
    method: 'POST',
    data:qs.stringify(params)
  })
}

// 增加附件信息
export const addAttachmentFile = params => {
  return request({
    url: '/api/attachmentFile',
    method: 'POST',
    data: qs.stringify(params)
  })
}

// 删除附件信息
export const delAttachmentFile = params => {
  return request({
    url: `/api/delAttachmentFile`,
    method: 'POST',
    data:qs.stringify(params)
  })
}




export const reportLable = params => {
  return request({
    url: '/api/reportLable',
    method: 'PUT',
    data: params
  })
}


export const changeRemark = (id, remark) => {
  return request({
    url: '/api/reportRemark',
    method: 'PUT',
    data: {
      'id': id,
      'remark': remark
    }
  })
}
